import { message } from 'antd'
import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/driverRequestActions'
import * as api from '../api/driverRequest'

function* fetchUnscheduledRequestList(action) {
  try {
    const payload = yield call(api.getUnscheduledRequestList, action)
    yield put({ type: constants.UNSCHEDULED_REQUEST_LIST_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UNSCHEDULED_REQUEST_LIST_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* fetchScheduledRequestList(action) {
  try {
    const payload = yield call(api.getScheduledRequestList, action)
    yield put({ type: constants.SCHEDULED_REQUEST_LIST_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SCHEDULED_REQUEST_LIST_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* updateDriverRequestDelivery(action) {
  try {
    yield call(api.editDriverRequestDelivery, action.id, action.payload)
    yield put({
      type: constants.DRIVER_REQUEST_DELIVERY_UPDATE.SUCCESS,
      id: action.id,
      payload: action.payload
    })
    yield put({ type: constants.SCHEDULED_REQUEST_LIST_REFRESH.ACTION })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRIVER_REQUEST_DELIVERY_UPDATE.FAILED,
      message: e.message || e
    })
  }
}
function* failedUpdateDriverRequestDelivery(action) {
  yield message.error(action.message)
}
function* succesfullUpdateDriverRequestDelivery(action) {
  const successMessage = `Driver request delivery was ${
    action.id ? 'Updated' : 'Created'
  } Succesfully`
  yield message.success(successMessage)
}

function* deleteDriverRequestDelivery(action) {
  try {
    yield call(
      api.deleteDriverRequestDelivery,
      action.driverRequestId,
      action.scheduleId,
      action.payload
    )

    yield put({
      type: constants.DRIVER_REQUEST_DELIVERY_DELETE.SUCCESS
    })
    yield put({ type: constants.SCHEDULED_REQUEST_LIST_REFRESH.ACTION })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRIVER_REQUEST_DELIVERY_DELETE.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Sagas
 */
function* unscheduledRequestListRefresh() {
  yield takeLatest(constants.UNSCHEDULED_REQUEST_LIST_REFRESH.ACTION, fetchUnscheduledRequestList)
}

function* scheduledRequestListRefresh() {
  yield takeLatest(constants.SCHEDULED_REQUEST_LIST_REFRESH.ACTION, fetchScheduledRequestList)
}

function* driverRequestDeliveryUpdate() {
  yield takeLatest(constants.DRIVER_REQUEST_DELIVERY_UPDATE.ACTION, updateDriverRequestDelivery)
}

function* driverRequestDeliveryDelete() {
  yield takeLatest(constants.DRIVER_REQUEST_DELIVERY_DELETE.ACTION, deleteDriverRequestDelivery)
}
function* driverRequestDeliverUpdateFail() {
  yield takeLatest(
    constants.DRIVER_REQUEST_DELIVERY_UPDATE.FAILED,
    failedUpdateDriverRequestDelivery
  )
}
function* driverRequestDeliverUpdateSuccess() {
  yield takeLatest(
    constants.DRIVER_REQUEST_DELIVERY_UPDATE.SUCCESS,
    succesfullUpdateDriverRequestDelivery
  )
}
/**
 * Export the root saga by forking all available sagas.
 */

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(unscheduledRequestListRefresh),
    fork(scheduledRequestListRefresh),
    fork(driverRequestDeliveryUpdate),
    fork(driverRequestDeliveryDelete),
    fork(driverRequestDeliverUpdateFail),
    fork(driverRequestDeliverUpdateSuccess)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/driverRequestSaga.js